
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/client-testimonials",
      function () {
        return require("private-next-pages/client-testimonials.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/client-testimonials"])
      });
    }
  